var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOportunityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 126,
    viewBox: "0 0 121 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.695 39.5039C113.078 40.1184 113.256 40.8382 113.204 41.5601L108.27 108.438C108.242 108.861 108.114 109.272 107.898 109.637C107.681 110.001 107.382 110.31 107.024 110.539C103.907 112.468 95.7519 116.17 95.7519 116.17C96.2328 115.87 96.5842 115.401 96.7368 114.856L102.027 41.4249C104.152 39.5977 107.61 38.0619 112.667 39.5221L112.695 39.5039Z",
    fill: "url(#paint0_linear_510_3217)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9336 28.6535L14.4797 64.4493L17.7928 68.9931L89.722 96.6677L101.077 44.9745L67.8484 59.0829L42.9572 64.8128L42.9354 64.2934L42.564 55.4633L11.9336 28.6535Z",
    fill: "#444444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6819 55.5004L37.2207 48.4033L47.0896 47.9882L57.74 53.7843L55.7934 56.9882L41.6819 55.5004Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5515 63.7891L41.3379 59.6773C43.6033 59.929 48.2379 60.4279 48.6534 60.4104C49.0689 60.393 47.9188 63.5633 47.2918 65.1507L42.5515 63.7891Z",
    fill: "#D3D3D3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.675 39.4832C107.619 38.023 104.16 39.5588 102.035 41.386C100.91 42.3513 99.9974 43.5405 99.3568 44.8778C98.7938 46.1938 94.6909 66.875 93.9512 67.7685C93.2115 68.662 90.9436 68.0797 87.1798 67.4357C84.4102 66.9623 63.9124 62.9051 53.4117 60.8304C53.6507 59.4682 53.8483 58.4408 53.8483 58.4408L54.6442 58.2368L55.3178 53.9874L42.6992 49.4757L40.6581 49.8732L40.0585 54.4341L40.8907 54.728L40.6645 56.5449L11.3948 42.7751C11.3948 42.7751 9.98787 41.9935 8.59266 41.0322C7.48241 40.2541 6.3981 39.3594 5.99801 38.6143C5.08957 36.9224 6.13869 30.6848 6.13869 30.6848C9.36463 13.4268 9.99054 12.3513 12.9433 10.5182C15.896 8.68512 21.1006 10.1072 21.1006 10.1072L38.7226 15.6019L36.9326 15.7454L33.4857 17.0254L33.2377 17.7503L40.1252 20.1229L42.9714 18.8024L43.0654 17.6186C46.0073 18.6554 62.4946 24.3474 65.5219 24.9233C67.6113 25.3226 68.4644 25.1583 68.8117 24.9894L69.0787 25.072L69.3465 28.7984L76.2458 31.1015L79.1676 29.777L78.6475 28.7174L76.712 27.4548L111.038 38.2049L111.059 38.2218L112.675 39.4832Z",
    fill: "url(#paint1_linear_510_3217)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.674 39.4833L111.07 38.232C111.07 38.232 111.108 38.2281 111.119 38.2269C111.761 38.4649 112.307 38.9062 112.674 39.4833Z",
    fill: "#595959"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.031 41.409L96.7407 114.84C96.5881 115.386 96.2368 115.854 95.7558 116.154C93.3382 117.65 88.0937 114.815 88.0937 114.815L50.1592 99.5634C50.1592 99.5634 47.4443 98.4802 43.4198 96.86C43.5738 76.0973 45.5638 67.6421 45.9861 66.1051L50.6724 67.6948C50.6724 67.6948 52.1684 67.464 52.2121 67.3721C52.2558 67.2802 52.9181 63.4726 53.3882 60.8553C63.8626 62.9328 84.3872 66.991 87.1564 67.4606C90.9048 68.1024 93.1882 68.6869 93.9279 67.7934C94.6675 66.8999 98.7703 46.2188 99.3333 44.9028C99.9792 43.563 100.898 42.373 102.031 41.409Z",
    fill: "url(#paint2_linear_510_3217)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6377 28.7033L79.1578 29.7629L76.236 31.0874L75.8617 29.9672L78.6377 28.7033Z",
    fill: "#D3D3D3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7029 27.4405L78.6384 28.7031L75.8624 29.9669L71.689 27.3476L74.3976 25.9464L76.6878 27.4421L76.7029 27.4405Z",
    fill: "#D3D3D3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8948 21.314L74.3963 25.9463L71.6877 27.3475L70.2938 22.5065L72.8948 21.314Z",
    fill: "#F7F7F7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8939 21.3142L70.2929 22.5067L68.8574 22.1841L71.6567 20.9977L72.8939 21.3142Z",
    fill: "#D6D6D6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6868 27.3479L75.8602 29.9672L76.2345 31.0874L69.3351 28.7844L69.0673 25.0579L69.0381 24.776L68.8573 22.1842L70.2928 22.5069L71.6868 27.3479Z",
    fill: "#BABABA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6696 20.9966L68.8704 22.183C60.4327 18.1963 51.8679 15.0739 43.1449 13.3243C42.7211 13.2314 42.3219 13.1549 41.903 13.0729C41.903 13.0729 41.9368 13.0694 41.9574 13.0482C42.9452 12.627 44.0172 12.4406 45.0891 12.5037C49.2245 13.0523 53.3042 13.96 57.2821 15.2165C62.1872 16.8592 66.9913 18.7893 71.6696 20.9966Z",
    fill: "url(#paint3_linear_510_3217)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8578 22.184L69.0386 24.7757L69.0678 25.0576L68.8009 24.9751C68.4385 25.1456 67.6004 25.3083 65.511 24.909C62.4857 24.3519 45.9965 18.6411 43.0546 17.6042C42.7598 17.5094 42.5978 17.4501 42.5978 17.4501C42.2371 17.1755 41.9149 16.8535 41.64 16.4929C41.17 15.9526 40.918 15.2568 40.9327 14.5408C40.9328 14.37 40.952 14.1998 40.9903 14.0333C41.034 13.7238 41.1847 13.4393 41.4163 13.2293L41.8535 13.0852L41.8799 13.0825C42.2987 13.1645 42.698 13.241 43.1218 13.3339C51.8552 15.0748 60.4201 18.1972 68.8578 22.184Z",
    fill: "url(#paint4_linear_510_3217)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5213 13.8132L41.4166 13.2181C41.185 13.4281 41.0343 13.7126 40.9906 14.0222L40.5753 14.1943L39.5213 13.8132Z",
    fill: "#C9C9C9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0547 17.6081L42.9606 18.792L40.1144 20.1125L40.4233 16.1212L41.6401 16.4968C41.915 16.8574 42.2371 17.1794 42.5979 17.454C42.5979 17.454 42.7595 17.5095 43.0547 17.6081Z",
    fill: "#999999"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5681 14.2065L40.9834 14.0343C40.9451 14.2008 40.9258 14.371 40.9258 14.5419C40.911 15.2578 41.1631 15.9536 41.6331 16.4939L40.4164 16.1183L40.5681 14.2065Z",
    fill: "#999999"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5754 14.2055L40.4237 16.1173L38.7122 15.5877L39.5203 13.8131L40.5754 14.2055Z",
    fill: "#E3E3E3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4228 16.1176L40.1138 20.1089L33.2263 17.7362L33.4739 17.0076L38.1376 16.8746L38.7112 15.5879L40.4228 16.1176Z",
    fill: "#E3E3E3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2956 54.0161L54.6217 58.2618L53.8259 58.4658L52.9157 58.7043L53.4724 54.353L55.2956 54.0161Z",
    fill: "#BABABA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7143 15.5876L38.1406 16.8742L33.477 17.0073L36.9242 15.731L38.7143 15.5876Z",
    fill: "#C9C9C9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4723 54.3529L52.9156 58.7042L52.1212 58.4445L50.6253 57.9419L49.6813 57.633L49.4159 59.4008L43.1903 57.3662L43.4252 55.5598L40.8792 54.7137L40.0485 54.4349L40.6481 49.8739L53.4723 54.3529Z",
    fill: "#DCDCDC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9163 58.7043L53.8265 58.4657C53.8265 58.4657 53.6288 59.4931 53.3898 60.8554C52.9197 63.4727 52.2319 67.3284 52.2136 67.3721C52.1954 67.4158 50.674 67.6948 50.674 67.6948L51.7982 60.5299L52.122 58.4445L52.9163 58.7043Z",
    fill: "#BABABA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1207 58.4447L51.7969 60.53L50.6614 67.6961L45.9752 66.1064L45.6912 66.0066L45.4231 65.9127L39.7052 63.9738L40.6412 56.532L40.8674 54.7151L43.4134 55.5612L43.1786 57.3676L49.4041 59.4022L49.6695 57.6344L50.6135 57.9433L52.1207 58.4447ZM47.1084 62.406C47.1319 62.1867 47.1118 61.9649 47.0494 61.7534C46.9869 61.5419 46.8833 61.3448 46.7444 61.1735C46.6056 61.0021 46.4343 60.8599 46.2403 60.7549C46.0464 60.65 45.8335 60.5844 45.6141 60.5619L45.0571 60.5398L44.884 60.5197C44.4481 60.5505 44.0387 60.7402 43.7334 61.0528C43.4281 61.3655 43.2482 61.7793 43.2278 62.2158C43.2073 62.6523 43.3478 63.0811 43.6225 63.4209C43.8973 63.7607 44.2873 63.9878 44.7184 64.0592L45.4485 64.1014C45.8921 64.0927 46.3146 63.9101 46.6251 63.593C46.9355 63.276 47.109 62.8497 47.1084 62.406Z",
    fill: "#A3A3A3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6166 60.5693C45.8359 60.5918 46.0488 60.6574 46.2428 60.7623C46.4367 60.8673 46.608 61.0095 46.7469 61.1808C46.8857 61.3522 46.9893 61.5493 47.0518 61.7608C47.1142 61.9723 47.1343 62.1941 47.1108 62.4133C47.1105 62.8565 46.9364 63.2818 46.626 63.5981C46.3156 63.9144 45.8936 64.0964 45.4505 64.1051L44.7204 64.0628C44.9407 64.062 45.1586 64.0174 45.3614 63.9317C45.5643 63.846 45.7481 63.7208 45.9022 63.5634C46.0563 63.4061 46.1776 63.2197 46.2591 63.0151C46.3406 62.8105 46.3806 62.5917 46.3768 62.3715C46.4118 61.9925 46.3212 61.6125 46.1189 61.2902C45.9166 60.9678 45.6139 60.7209 45.2575 60.5874C45.1965 60.5658 45.1338 60.5494 45.07 60.5384L45.6166 60.5693Z",
    fill: "#999999"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M45.256 60.5912C45.6124 60.7247 45.9151 60.9716 46.1174 61.294C46.3197 61.6163 46.4103 61.9963 46.3753 62.3753C46.3242 62.6749 46.1877 62.9534 45.9823 63.1773C45.7768 63.4013 45.511 63.5612 45.2169 63.638C44.9228 63.7147 44.6128 63.705 44.3241 63.61C44.0354 63.5149 43.7803 63.3386 43.5892 63.1022C43.3982 62.8658 43.2794 62.5793 43.2472 62.2771C43.2149 61.9749 43.2704 61.6698 43.4072 61.3983C43.5439 61.1269 43.7561 60.9007 44.0182 60.7468C44.2804 60.593 44.5813 60.518 44.885 60.5308L45.058 60.5509C45.1218 60.5619 45.1845 60.5783 45.2455 60.5999L45.256 60.5912Z",
    fill: "#D3D3D3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7047 66.0053L45.9886 66.1051C45.5663 67.6421 43.5763 76.0974 43.4223 96.8601C43.3421 96.819 43.2409 96.7952 43.1602 96.7504C43.0796 96.7055 42.9459 96.6624 42.8277 96.6214C42.9888 76.4051 44.8358 68.0369 45.4198 65.9322C45.4198 65.9322 45.4198 65.9322 45.4367 65.9114L45.7047 66.0053Z",
    fill: "#2A3144"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4364 65.9113C45.4364 65.9113 45.4364 65.9113 45.4195 65.9321C44.8356 68.0368 42.9886 76.405 42.8274 96.6213C31.6237 92.1228 11.334 83.9821 9.91824 83.3725C7.93033 82.5219 7.12377 80.0519 7.12377 80.0519C7.12377 80.0519 7.41819 77.6466 7.2338 69.5494C7.04942 61.4521 8.58763 41.0668 8.58763 41.0668L8.58258 41.0179C9.97778 41.9792 11.3847 42.7608 11.3847 42.7608L40.6544 56.5306L39.7185 63.9724L45.4364 65.9113Z",
    fill: "url(#paint5_linear_510_3217)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_510_3217",
    x1: 100.456,
    y1: 39.744,
    x2: 108.231,
    y2: 114.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22293E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_510_3217",
    x1: 66.3145,
    y1: 10.236,
    x2: 62.587,
    y2: 71.3474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4852B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#456891"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_510_3217",
    x1: 70.1969,
    y1: 44.7034,
    x2: 77.8118,
    y2: 118.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4D61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_510_3217",
    x1: 56.1891,
    y1: 11.2637,
    x2: 57.4415,
    y2: 23.3657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4759A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#839AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_510_3217",
    x1: 54.2058,
    y1: 11.8069,
    x2: 55.72,
    y2: 26.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E3462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3F59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_510_3217",
    x1: 22.8198,
    y1: 39.5445,
    x2: 28.8759,
    y2: 98.0651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4D61"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOportunityIcon);
export default __webpack_public_path__ + "static/media/OportunityIcon.ce13eb1388a7a7c86a4eb9f0338cdcf1.svg";
export { ForwardRef as ReactComponent };